import BtnCartAnimated from './BtnCartAnimated'

export default BtnCartAnimated
